import React, { useEffect, useState, useMemo } from 'react'
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from '../../shared/Paginator';
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import Select from 'react-select';
import Datepicker from 'react-tailwindcss-datepicker';
import UploadModal from './components/UploadModal';

const AssignedAds = ({ pickDesign, assignedDesigns, setassignedDesigns, totalassigned, settotalassigned, activechild, loader, currentPage, setCurrentPage, handlePageChange, getassignedDesigns,dateRange,setDateRange,adType,setAdType,search,setSearch}) => {

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedCreative, setSelectedCreative] = useState(null);

  useEffect(() => {
    setCurrentPage(0);
  }, [activechild])


  const handleUploadClick = (creativeId, creativeType) => {
    setSelectedCreative({ id: creativeId, type: creativeType });
    setShowUploadModal(true);
  };

  const handleUploadSuccess = (result) => {
    // Refresh data as needed
    console.log('Upload successful:', result);
  };

  const handleUploadError = (error) => {
    console.error('Upload failed:', error);
  };

  // Handle click outside to close any open menus
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close any open menus when clicking outside
      const menus = document.querySelectorAll('[data-menu]');
      let clickedOutside = true;
      
      menus.forEach(menu => {
        if (menu.contains(event.target)) {
          clickedOutside = false;
        }
      });
      
      if (clickedOutside) {
        // Close any open menus
        // Add specific menu close logic here if needed
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <ScrollContainer>
        <table className="table table-bordered">
          <thead>
            <tr className="bg-gray-100">
              {/* <th className="p-2 text-left">Sales Person Details</th> */}
              {/* <th>Ad Creation Date</th> */}
              {/* <th>Brand</th> */}
              <th>Campaign Name</th>
              {/* <th>Start Date</th> */}
              {/* <th>End Date</th> */}
              <th>Ad Type</th>
              <th>Adops</th>
              <th>Assign Time</th>
              <th>Action</th>
            </tr>
          </thead>
            {(assignedDesigns.length > 0 && !loader) ? (assignedDesigns.map((row, idx) => {
              const created_at = alphaformatDateTime(row.created_at);
              const start_date = alphaformatDateTime(row.creative_start_date);
              const end_date = alphaformatDateTime(row.creative_end_date);
              const assign_time = alphaformatDateTime(row.assigndate);

              return (
              <tbody>
                <tr key={idx} className="border-t">
                  {/* <td className="p-2">
                    <div className="flex items-center gap-1">
                      <sl-icon name="person" />
                      <span>{row.sales_person.sales_person_name}</span>
                    </div>
                    <div className="text-xs text-gray-500 flex items-center gap-1">
                      <sl-icon name="telephone" />
                      <span>{row.sales_person.mobile}</span>
                    </div>
                  </td>
                  <td>
                    <div className='font-bold'>{created_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{created_at.timeStr}</div>
                  </td> */}
                  {/* <td>{row.brand_name}</td> */}
                  <td>{row.creative_name}</td>
                  {/* <td className="p-2">
                    <div className='font-bold'>{start_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{start_date.timeStr}</div>
                  </td> */}
                  {/* <td className="p-2">
                    <div className='font-bold'>{end_date.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{end_date.timeStr}</div>
                  </td> */}
                  <td>{row.ad_type}</td>
                  <td>{row.cst_name}</td>
                  <td>
                    <div className='font-bold'>{assign_time.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{assign_time.timeStr}</div>
                  </td>
                  <td>
                    <button className="bg-blue-600 text-white px-3 py-1 rounded"
                      onClick={() => {
                        pickDesign(row.creative_id);
                      }}>
                      Pick Ad
                    </button>
                  </td>
                </tr></tbody>
              )
            })) : (!assignedDesigns.length > 0 && !loader ) ? (<NoDataFound colspan="10" />)
          : (<TableLoader colspan="10"/>)}
        </table>
      </ScrollContainer>
      <div className="flex justify-end">
        {Math.ceil(totalassigned / config.PER_PAGE)  > 1 && (
          <Paginator
            pageCount={Math.ceil(totalassigned / config.PER_PAGE)}
            handlePageClick={handlePageChange}
            forcePage={currentPage}
          />)
        }
      </div>
      <UploadModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onUploadSuccess={handleUploadSuccess}
        onUploadError={handleUploadError}
        creativeId={selectedCreative?.id}
        creativeType={selectedCreative?.type}
      />
    </div>
  );
};
export default AssignedAds;